import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { endAuthSession } from '@/lib/api/auth';
import { trackLogoutCompleted } from '@/lib/analytics/trackers/auth';
import { showErrorToast, showSuccessToast } from '@/utils/toast-utils';

export const useLogout = () => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    // Show confirmation dialog
    const confirmed = window.confirm('Are you sure you want to log out?');
    
    if (!confirmed) {
      return;
    }

    setIsLoggingOut(true);
    
    try {
      trackLogoutCompleted();
      // Revoke the session server-side (best effort) and clear all local auth data
      endAuthSession();
      
      // Show success toast
      showSuccessToast("Logged out successfully", "You have been logged out of your account.");
      
      // Navigate to landing page
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
      showErrorToast(error, "Logout failed");
    } finally {
      setIsLoggingOut(false);
    }
  };

  return {
    handleLogout,
    isLoggingOut
  };
};
